module.exports = __webpack_public_path__ + "img/g6.3c4a2da6.jpg";